import { newSpecPage, SpecPage } from "@stencil/core/testing";
import { SallaRatingStars } from "../salla-rating-stars";


describe('salla rating stars', () => {
    it('should build', () => {
        expect(new SallaRatingStars()).toBeTruthy();
    })

    describe('checking for props', () => {
        let page: SpecPage;
        let element;

        beforeEach(async () => {
            page = await newSpecPage({
                components: [SallaRatingStars],
                html: '<salla-rating-stars></salla-rating-stars>'
            });
            element = await page.doc.querySelector('salla-rating-stars');
        })

        it('should work for name prop', async () => {
            element.name = 'rating';
            await page.waitForChanges();
            expect(element.name).toBe('rating');
        })

        it('should work for size prop', async () => {
            element.size = 'small';
            await page.waitForChanges();
            expect(element.size).toBe('small');
        })

        it('should work for value prop', async () => {
            element.value = 5;
            await page.waitForChanges();
            expect(element.value).toBe(5);
        })

    })

    describe('checking for events', () => {
        let page: SpecPage;
        //@ts-ignore
        let element;

        beforeEach(async () => {
            page = await newSpecPage({
                components: [SallaRatingStars],
                html: '<salla-rating-stars></salla-rating-stars>'
            });
            element = await page.doc.querySelector('salla-rating-stars');
        })

        it('should initiate rating on click event', async () => {
            const starBtn = await page.doc.querySelector('button')
            starBtn.click()
            await page.waitForChanges()

        })
    })
})
